import Text from '@cartwhl/ui/base/TextNew';
import Button from '@cartwhl/ui/input/Button';
import Modal from '@cartwhl/ui/molecules/Modal';

export interface AssetLibraryMoveToTrashModalProps {
  open: boolean;
  loading: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export default function AssetLibraryMoveToTrashModal({
  open,
  loading,
  onOpenChange,
  onConfirm,
}: AssetLibraryMoveToTrashModalProps) {
  return (
    <Modal
      open={open}
      onOpenChange={(nextOpen) => {
        if (!loading) {
          onOpenChange(nextOpen);
        }
      }}
      maxWidth={520}
      horizontalBleed
      verticalBleed
    >
      <div className="flex flex-col gap-4 px-5 pt-6 pb-6">
        <Text token="display/16/medium" leading="headline" className="text-primary">
          Move to trash?
        </Text>
        <Text token="14/medium" className="text-tertiary text-pretty">
          Are you sure you want to move this to the trash? Items in the trash
          will be permanently deleted within 30 days.
        </Text>
        <div className="flex gap-3 pt-2">
          <Button
            type="button"
            variant="secondary"
            size="lg"
            className="flex-1"
            disabled={loading}
            onClick={() => onOpenChange(false)}
          >
            Close
          </Button>
          <Button
            type="button"
            variant="primary-destructive"
            size="lg"
            className="flex-1"
            loading={loading}
            disabled={loading}
            onClick={onConfirm}
          >
            Move to trash
          </Button>
        </div>
      </div>
    </Modal>
  );
}
